import { useContext } from "react";
import { showSuccessMessage } from "@beeldit/core/helpers/messagesHelper";
import { FloppyDisk } from "@phosphor-icons/react/dist/ssr";
import { DetailsByPageableActionContext } from "../detailsByPageable/DetailsByPageableActionContext";
import { DetailsActionContext } from "../details/DetailsActionContext";
import useUpdateMainData from "./useUpdateMainData";

function useUpdateMainDataAction(): any {
  const { element: page, selectedLang } = useContext(
    DetailsByPageableActionContext
  );
  const { element: page2, selectedLang: selectedLang2 } =
    useContext(DetailsActionContext);

  const finalPage = page || page2;
  const finalSelectedLang = selectedLang || selectedLang2;
  // const finalSetPage = page ? setPage : setPage2;

  /**
   * Form store success function definition
   */
  const onSuccessUpdate = (section: any) => {
    showSuccessMessage("successfull_action");
  };

  const updateMainData = useUpdateMainData();
  const updateMainDataFunction = () => {
    finalPage.lang = finalSelectedLang;
    updateMainData(finalPage.id, finalPage, onSuccessUpdate);
  };

  const actionTemplate = (
    <div className="d-inline">
      <button
        type="button"
        className="btn btn-link p-0"
        onClick={() => {
          updateMainDataFunction();
        }}
        aria-label="Save main data"
      >
        <FloppyDisk size={24} />
      </button>
    </div>
  );

  /** END EDIT FORM ACTION */

  return {
    actionTemplate,
  };
}

export default useUpdateMainDataAction;
